// frontend/src/utils/dossierKleuren.ts
//
// Vaste kleuren voor dossier-dimensies (expertiseType, status) in het
// financieel dashboard. Kleur volgt de entiteit, niet de rang. De volgorde is
// tevens de vaste segmentvolgorde in mix-staafjes: aangrenzende paren zijn met
// de dataviz-validator gecheckt (adjacent-pairs, light, 2026-07-29) — niet
// herschikken of hertinten zonder opnieuw te valideren.

export const EXPERTISE_TYPE_VOLGORDE = [
  "WA",
  "ONG",
  "AO",
  "KGO",
  "BA",
  "SE",
  "SO",
  "OVERIG",
] as const;

export const EXPERTISE_TYPE_KLEUREN: Record<string, string> = {
  WA: "#0072B2",
  ONG: "#E69F00",
  AO: "#7C4FA3",
  KGO: "#009E73",
  BA: "#D55E00",
  SE: "#CC79A7",
  SO: "#56B4E9",
  OVERIG: "#995C00",
};

/** Neutrale restkleur voor '(onbekend)'/ontbrekende waarden. */
export const KLEUR_TYPE_REST = "#9ca3af";

export const expertiseTypeKleur = (type: string | null | undefined): string =>
  (type && EXPERTISE_TYPE_KLEUREN[type]) || KLEUR_TYPE_REST;

export const STATUS_VOLGORDE = ["ACTIEF", "VOLTOOID", "GEANNULEERD"] as const;

export const STATUS_LETTERS: Record<string, string> = {
  ACTIEF: "A",
  VOLTOOID: "V",
  GEANNULEERD: "G",
};

export const STATUS_LABELS: Record<string, string> = {
  ACTIEF: "Actief",
  VOLTOOID: "Voltooid",
  GEANNULEERD: "Geannuleerd",
};

/** GEANNULEERD is bewust neutraal grijs (inactieve status). */
export const STATUS_KLEUREN: Record<string, string> = {
  ACTIEF: "#2a78d6",
  VOLTOOID: "#008300",
  GEANNULEERD: "#9ca3af",
};

export const statusKleur = (status: string | null | undefined): string =>
  (status && STATUS_KLEUREN[status]) || KLEUR_TYPE_REST;
